var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialemissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16514 3.63787C8.31975 3.58165 8.48921 3.58165 8.64382 3.63787L16.3478 6.43931C16.6152 6.53655 16.7972 6.78591 16.8083 7.07024C16.8193 7.35457 16.6573 7.61734 16.3982 7.73508L8.69429 11.2369C8.51015 11.3206 8.29881 11.3206 8.11467 11.2369L0.41072 7.73508C0.151681 7.61734 -0.010372 7.35457 0.000701999 7.07024C0.011776 6.78591 0.193775 6.53655 0.461188 6.43931L8.16514 3.63787ZM2.55164 7.1696L8.40448 9.82998L14.2573 7.1696L8.40448 5.04129L2.55164 7.1696ZM0.062947 11.36C0.223005 11.0079 0.638214 10.8522 0.990341 11.0122L8.40448 14.3823L15.8186 11.0122C16.1707 10.8522 16.586 11.0079 16.746 11.36C16.9061 11.7121 16.7504 12.1274 16.3982 12.2874L8.69429 15.7892C8.51015 15.8729 8.29881 15.8729 8.11467 15.7892L0.41072 12.2874C0.0585922 12.1274 -0.0971109 11.7121 0.062947 11.36ZM0.062947 15.9124C0.223005 15.5602 0.638214 15.4045 0.990341 15.5646L8.40448 18.9346L15.8186 15.5646C16.1707 15.4045 16.586 15.5602 16.746 15.9124C16.9061 16.2645 16.7504 16.6797 16.3982 16.8398L8.69429 20.3415C8.51015 20.4252 8.29881 20.4252 8.11467 20.3415L0.41072 16.8398C0.0585922 16.6797 -0.0971109 16.2645 0.062947 15.9124Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialemissions);
export default __webpack_public_path__ + "static/media/materialemissions.37b1b8760307d04109e2f4ad5575adca.svg";
export { ForwardRef as ReactComponent };